import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'carbon-react/lib/components/button';
import classNames from 'classnames';

import { FormattedMessage } from '@futrli/localisation';

import styles from './header.scss';

interface HeaderProps {
  position?: 'fixed' | 'sticky';
  rightContent?: ReactNode;
  title: string | ReactNode;
  style?: React.CSSProperties;
}

export const Header = ({ position, rightContent, title, style }: HeaderProps) => {
  const navigate = useNavigate();

  const handleExitClick = () => {
    navigate(-1);
  };

  const defaultRightContent = () => {
    return (
      <Button onClick={handleExitClick} buttonType="secondary" size="medium" mr="6px">
        <FormattedMessage id="common.exit" defaultMessage="Exit" />
      </Button>
    );
  };

  return (
    <div className={classNames(styles.appBar, { [styles.fixed]: position === 'fixed' })} style={style}>
      <div className={classNames(styles.headerBar, styles.wideScreen)}>
        <div className={styles.headerContent}>
          <div>{title}</div>
          <div>{rightContent || defaultRightContent()}</div>
        </div>
      </div>
    </div>
  );
};
